import { useState, useEffect, useCallback } from "react";
import { useAuth, API } from "../App";
import axios from "axios";
import { Heart } from "lucide-react";
import { toast } from "sonner";

const WishlistButton = ({ productId, className = "" }) => {
  const { user, token } = useAuth();
  const [isFav, setIsFav] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && token) {
      checkWishlist();
    }
  }, [user, token, productId]);

  const checkWishlist = async () => {
    try {
      const response = await axios.get(`${API}/wishlist/ids`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setIsFav(response.data.product_ids.includes(productId));
    } catch {
      // silently fail
    }
  };

  const toggle = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!user) {
      toast.error("Please sign in to save favourites");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${API}/wishlist/${productId}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setIsFav(response.data.added);
      toast.success(response.data.message);
    } catch (error) {
      toast.error("Failed to update favourites");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={loading}
      className={`w-9 h-9 rounded-full bg-white/90 flex items-center justify-center hover:bg-white transition-all shadow-sm ${className}`}
      data-testid={`wishlist-btn-${productId}`}
      aria-label={isFav ? "Remove from favourites" : "Add to favourites"}
    >
      <Heart
        size={18}
        className={`transition-colors ${isFav ? "fill-[#F06570] text-[#F06570]" : "text-[#5C5D5C]"}`}
      />
    </button>
  );
};

export default WishlistButton;
